import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-795eb5b4"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "comment-container"
};
const _hoisted_2 = {
  class: "swiper mySwiper"
};
const _hoisted_3 = {
  class: "swiper-wrapper"
};
const _hoisted_4 = {
  class: "comment-img"
};
const _hoisted_5 = ["src"];
const _hoisted_6 = {
  class: "comment-title"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "swiper-pagination"
}, null, -1));
const _hoisted_8 = {
  class: "comment-guide"
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("iconpark-icon", {
  name: "jiantou",
  size: "20"
}, null, -1));
const _hoisted_10 = [_hoisted_9];
const _hoisted_11 = {
  class: "guide-center"
};
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("iconpark-icon", {
  name: "jiantou",
  size: "20"
}, null, -1));
const _hoisted_13 = [_hoisted_12];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Title = _resolveComponent("Title");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_Title, {
    title: "User Reviews"
  }), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.commentData, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: _normalizeClass(["swiper-slide", item.class]),
      key: index
    }, [_createElementVNode("div", _hoisted_4, [_createElementVNode("img", {
      src: item.img,
      alt: "",
      width: "100%"
    }, null, 8, _hoisted_5)]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", null, _toDisplayString(item.title), 1)]), _createElementVNode("p", null, _toDisplayString(item.content), 1)], 2);
  }), 128))]), _hoisted_7]), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", {
    class: "guide-left",
    onClick: _cache[0] || (_cache[0] =
    //@ts-ignore
    (...args) => _ctx.prev && _ctx.prev(...args))
  }, _hoisted_10), _createElementVNode("div", _hoisted_11, [_createElementVNode("div", {
    class: "guide-center-box",
    style: _normalizeStyle({
      width: _ctx.progess()
    })
  }, null, 4)]), _createElementVNode("div", {
    class: "guide-left",
    onClick: _cache[1] || (_cache[1] =
    //@ts-ignore
    (...args) => _ctx.next && _ctx.next(...args))
  }, _hoisted_13)])]);
}